import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { Lock } from "lucide-react";
import { useAuth } from "../../context/AuthContext";
import { formatError } from "../../lib/api";
import { useSeo } from "../../lib/hooks";

export default function AdminLogin() {
  useSeo({ title: "Administration" });
  const { user, login, logout } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  if (user?.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const u = await login(email, password);
      if (u.role !== "admin") { await logout(); setError("Accès réservé à l'administrateur."); return; }
      nav("/admin");
    }
    catch (err) { setError(formatError(err)); }
    finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-5 bg-[#0B0B0B]" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-[#C9A45C]/25 bg-[#101010] p-8">
        <img src="/logo-nasdeal.jpg" alt="NasDeal" className="h-24 w-24 mx-auto" />
        <p className="eyebrow text-center mt-4">Espace administrateur</p>
        <label className="block mt-8 text-[10px] tracking-[0.2em] uppercase text-[#F8F6F1]/50">E-mail
          <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} autoComplete="username" className="mt-1.5 w-full bg-transparent border border-[#C9A45C]/25 px-4 py-3 text-sm outline-none focus:border-[#C9A45C] normal-case tracking-normal text-[#F8F6F1]" data-testid="admin-login-email" />
        </label>
        <label className="block mt-4 text-[10px] tracking-[0.2em] uppercase text-[#F8F6F1]/50">Mot de passe
          <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} autoComplete="current-password" className="mt-1.5 w-full bg-transparent border border-[#C9A45C]/25 px-4 py-3 text-sm outline-none focus:border-[#C9A45C] normal-case tracking-normal text-[#F8F6F1]" data-testid="admin-login-password" />
        </label>
        {error && <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>}
        <button type="submit" disabled={loading} className="btn-gold w-full mt-6" data-testid="admin-login-submit"><Lock className="h-4 w-4" />{loading ? "Connexion…" : "Se connecter"}</button>
        <Link to="/" className="block text-center mt-6 text-xs text-[#F8F6F1]/45 hover:text-[#C9A45C]">← Retour à la boutique</Link>
      </form>
    </div>
  );
}
